import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { platformFeatures, POST_TYPE_KEY } from '../../config/platformFeatures';
import { FACEBOOK, PLATFORMS_COLORS } from '../../../../config/constants';
import { useTranslate } from '@tolgee/react';
import { Tab, Tabs } from 'react-bootstrap';
import './styles.css';
import {
  PLATFORM_COLORS,
  PLATFORM_ICONS,
  additonalPlatformIcons
} from '../../../../config/icons';
import CreatorTitle from '../commonElements/creatorTitle';
import CreatorCard from '../commonElements/creatorCard';

export const PostAdditionalOptions: React.FC<any> = () => {
  const { platformEnabled, general_post_type, postTypeSelected } = useSelector(
    (state: any) => state.lomavisCreator
  );
  const getFirstEnabledPlatformWithAdditionalOptionsEnabled = () => {
    return Object.keys(platformFeatures)
      .filter((platform) => platformEnabled[platform])
      .map((platform) => {
        const additionalOptions = platformFeatures[platform]?.[
          general_post_type
        ]?.find(
          (config) => config.typeKey === postTypeSelected[platform]
        )?.additionalOptions;
        return additionalOptions?.enabled ? platform : null;
      })
      .filter((option) => option !== null)?.[0];
  };

  const [activeKey, setActiveKey] = useState(
    getFirstEnabledPlatformWithAdditionalOptionsEnabled()
  );

  useEffect(() => {
    if (platformEnabled[activeKey]) return;
    const firstEnabledPlatform =
      getFirstEnabledPlatformWithAdditionalOptionsEnabled();
    setActiveKey(firstEnabledPlatform);
  }, [platformEnabled, general_post_type, postTypeSelected]);

  const getEnabledAdditionalOptionsLength = () => {
    return Object.keys(platformFeatures)
      .filter((platform) => platformEnabled[platform])
      .map((platform) => {
        const additionalOptions =
          platformFeatures[platform]?.[general_post_type]?.find(
            (config) => config.typeKey === postTypeSelected[platform]
          )?.additionalOptions ||
          platformFeatures[platform]?.[POST_TYPE_KEY]?.find(
            (config) => config.typeKey === general_post_type
          )?.additionalOptions;

        return additionalOptions?.enabled ? additionalOptions : null;
      })
      .filter((option) => option !== null).length;
  };

  if (getEnabledAdditionalOptionsLength() === 0) return null;

  return (
    <CreatorCard>
      <CreatorTitle title="additionalOptions" />
      <div>
        <Tabs
          id="fill-tab-example"
          className="mb-3"
          variant="pills"
          activeKey={activeKey}
          onSelect={(key) => {
            setActiveKey(key);
          }}
        >
          {Object.keys(platformFeatures)
            .filter((platform) => platformEnabled[platform])
            .map((platform) => {
              const additionalOptions =
                platformFeatures[platform]?.[general_post_type]?.find(
                  (config: any) => config.typeKey === postTypeSelected[platform]
                )?.additionalOptions ||
                platformFeatures[platform]?.[POST_TYPE_KEY]?.find(
                  (config: any) => config.typeKey === general_post_type
                )?.additionalOptions;

              if (!additionalOptions || !additionalOptions.enabled) return null;
              const Component = additionalOptions.component;
              return (
                <Tab
                  eventKey={platform}
                  key={platform}
                  title={
                    <div className="d-flex flex-column align-items-center justify-content-between text-center rounded cursor-pointer w-45px position-relative">
                      <div>
                        <i
                          className={`${PLATFORM_ICONS[platform]} fs-2x`}
                          style={{
                            color: PLATFORM_COLORS[platform]
                          }}
                        ></i>
                      </div>
                      <div
                        className="position-absolute"
                        style={{ marginLeft: '40px', marginTop: '15px' }}
                      >
                        {additonalPlatformIcons[platform] && (
                          <i className={additonalPlatformIcons[platform]}></i>
                        )}
                      </div>
                    </div>
                  }
                  className="additionalOptionsCollapseNavTab"
                  onClick={() => {
                    setActiveKey(platform);
                  }}
                >
                  <Component key={platform} platform={platform} />
                </Tab>
              );
            })}
        </Tabs>
      </div>
    </CreatorCard>
  );
};
